

import { getToken, setToken, removeToken } from '@/utils/auth'

import {
  saveLocalStorage,
  removeLocalStorage,
  getLocalStorageObject
} from '@/utils/auth.js'
import { createShop, listDataShop, updateShop, updateTeacherWeixinFlag, updateTeacherMobileFlag, updateTeacherDouyinFlag, updateTeacherKuaishouFlag } from '@/zsm-api-new/shop.js'
const state = {

}

const mutations = {

}

const actions = {
  // 更新讲师抖音的开启状态
  updateTeacherDouyinFlag({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateTeacherDouyinFlag(info).then(response => {
        removeLocalStorage('teacher_shop')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 更新讲师快手的开启状态
  updateTeacherKuaishouFlag({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateTeacherKuaishouFlag(info).then(response => {
        removeLocalStorage('teacher_shop')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 更新讲师微信的开启状态
  updateTeacherWeixinFlag({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateTeacherWeixinFlag(info).then(response => {
        removeLocalStorage('teacher_shop')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 更新讲师联系电话的开启状态
  updateTeacherMobileFlag({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateTeacherMobileFlag(info).then(response => {
        removeLocalStorage('teacher_shop')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 创建店铺
  createShop({ commit }, info) {
    return new Promise((resolve, reject) => {
      createShop(info).then(response => {
        removeLocalStorage('teacher_shop')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取店铺列表
  listDataShop({ commit }, info) {
    return new Promise((resolve, reject) => {
      let shopInfo = getLocalStorageObject('teacher_shop');
      if (info.platformDict && shopInfo && shopInfo.platformDict.indexOf(info.platformDict) != -1) {
        resolve({
          list: [shopInfo],
          count: 1
        })
      }
      else {
        listDataShop(info).then(response => {
          if (info.loginCode) {
            if (response.list.length > 0) {
              saveLocalStorage('teacher_shop', response.list[0])
            }
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      }

    })
  },

  // 获取店铺列表
  updateShop({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateShop(info).then(response => {
        removeLocalStorage('teacher_shop')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
